import { render } from "./HubBanner.vue?vue&type=template&id=4e6b1ce3"
import script from "./HubBanner.vue?vue&type=script&lang=js"
export * from "./HubBanner.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__